"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionCooldownModal = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("../button/Button");
const Modal_1 = require("../modal/Modal");
const Paragraph_1 = require("../paragraph/Paragraph");
const Spacer_1 = require("../spacer/Spacer");
const Heading_1 = require("../heading/Heading");
const StyleWrapper = styled_1.default.div `
	max-height: 30%;
`;
const buildCooloffDate = (promotionCooloffTime) => {
    const delta = Date.now() + Number.parseInt(promotionCooloffTime, 10);
    const cooloffDate = new Date(delta);
    return cooloffDate.toLocaleDateString();
};
const ConfirmPage = (props) => React.createElement(React.Fragment, null,
    React.createElement(Heading_1.HeadingSmall, null, "Deactivate Promotion?"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null,
        props.promotionName,
        " has a cooldown period. If deactivated, this promotion will be unavailable for your property will be unavailable until ",
        buildCooloffDate(props.promotionCooloffTime),
        "."),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Paragraph_1.Paragraph, null, "Are you sure you wish to deactivate?"));
var DeactivatePromotionModalPage;
(function (DeactivatePromotionModalPage) {
    DeactivatePromotionModalPage[DeactivatePromotionModalPage["ConfirmPage"] = 0] = "ConfirmPage";
})(DeactivatePromotionModalPage || (DeactivatePromotionModalPage = {}));
const buildPages = (promotionName, promotionCooloffTime) => ({
    [DeactivatePromotionModalPage.ConfirmPage]: React.createElement(ConfirmPage, { promotionName: promotionName, promotionCooloffTime: promotionCooloffTime }),
});
const buildModalButtons = (deactivate, close) => {
    const onDeactivate = (promotion) => {
        deactivate(promotion);
        close();
    };
    const btnDeactivateOpportunity = React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: onDeactivate }, "Deactivate Promotion");
    const btnCloseModal = React.createElement(Button_1.Button, { onClick: close }, "Keep Promotion");
    return { actionLHS: btnDeactivateOpportunity, actionRHS: btnCloseModal };
};
const PromotionCooldownModal = (props) => {
    const [currentPage] = React.useState(DeactivatePromotionModalPage.ConfirmPage);
    const modalPages = buildPages(props.promotionName, props.promotionCooloffTime);
    const page = modalPages[currentPage];
    const buttons = buildModalButtons(props.deactivate, props.close);
    return React.createElement(StyleWrapper, null,
        React.createElement(Modal_1.Modal, Object.assign({ title: "Deactivate promotion", onRequestClose: props.close }, buttons), page));
};
exports.PromotionCooldownModal = PromotionCooldownModal;
//# sourceMappingURL=PromotionCooldownModal.js.map